const LOCAL_SIGNALR_PROXY_PATH = '/api/proxy/signalr';

/**
 * Base URL for the Core upsertEntityHub (no trailing slash).
 * Prefer same-origin proxy in local dev to avoid cross-origin SignalR negotiate/CORS.
 */
export function getSignalRHubBaseUrl(): string {
  const configured = process.env.NEXT_PUBLIC_SIGNALR_HUB_URL?.trim();
  if (configured) {
    return configured.replace(/\/$/, '');
  }

  if (typeof window !== 'undefined') {
    return `${window.location.origin}${LOCAL_SIGNALR_PROXY_PATH}`;
  }

  return LOCAL_SIGNALR_PROXY_PATH;
}

export function buildUpsertEntityHubUrl(userGuid: string): string {
  return `${getSignalRHubBaseUrl()}/upsertEntityHub?userId=${encodeURIComponent(userGuid)}`;
}
